import { useEffect, useReducer } from "react";
import Api from "./api.js";

const BASE_URL = "/__api/v1";
const apiService = new Api();

const initialState = {
  status: "idle",
  response: null,
  error: null,
};

function requestReducer(defaultResponse) {
  return (state, action) => {
    const updatedState = { ...state };

    switch (action.type) {
      case "FETCHING":
        updatedState.status = "loading";
        updatedState.response = defaultResponse;
        updatedState.error = null;
        break;

      case "SUCCESS":
        updatedState.status = "success";
        updatedState.response = action.data;
        break;

      case "ERROR":
        updatedState.status = "error";
        updatedState.error = action.error;
        break;

      default:
        break;
    }

    return updatedState;
  };
}

export default function useApiService({ url, method = "get", payload, onMount, onSuccess, onError, defaultResponse }) {
  const [state, dispatch] = useReducer(requestReducer(defaultResponse), { ...initialState, response: defaultResponse });

  function sendRequest(requestPayload = payload) {
    dispatch({ type: "FETCHING" });
    apiService[method](`${BASE_URL}${url}`, requestPayload)
      .then(({ data }) => {
        dispatch({ type: "SUCCESS", data });
        onSuccess && onSuccess(data);
      })
      .catch((error) => {
        dispatch({ type: "ERROR", error });
        onError && onError(error);
      });
  }

  useEffect(() => {
    onMount && sendRequest(payload);
  }, []);

  const isIdle = state.status === "idle";
  const isLoading = state.status === "loading";
  const isSuccess = state.status === "success";
  const isError = state.status === "error";

  return [{ ...state, isIdle, isLoading, isSuccess, isError }, sendRequest];
}



// WEBPACK FOOTER //
// ./src/services/useApiService.js